export default __webpack_public_path__ + "static/hadecs-ee40e7cd19ae724c0d1d08a17224ec62.png";